import PropertySearch from '../components/PropertySearch';

export default function Leasing() {
  return (
    <PropertySearch
      listingTypes={['rent', 'lease']}
      title="Property Leasing"
      subtitle="Find Your Perfect Space"
      allowLeasingType
    />
  );
}
